<!-- Status-header types (warning/info/error) get their surface background from
     .mat-mdc-dialog-surface in material-ui.scss (single source); this div stays transparent. -->
<div
  class="tw-relative tw-p-10"
  data-testid="confirmation-dialog"
  [class.tw-rounded-lg]="isStandard"
  [class.tw-bg-dt-surface-card]="isStandard"
>
  @if (data.dismissible && !isReloading) {
    <close-button type="plain" class="tw-absolute tw-right-4 tw-top-4"></close-button>
  }
  @if (isReloading) {
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-6 tw-py-6">
      <mat-spinner diameter="48" aria-hidden="true"></mat-spinner>
      <div class="tw-text-center tw-text-lg tw-font-medium tw-text-dt-text-action">
        {{ "reloadingApp" | i18n }}
      </div>
      <p class="tw-text-center tw-text-sm tw-text-gray-600">
        {{ "reloadingAppHint" | i18n }}
      </p>
    </div>
  } @else if (data.templateContent) {
    <!--    todo: for confirming plan, need to standardize it later otherwise might confuse-->
    <div class="tw-mb-10 tw-text-[24px] tw-font-medium tw-text-center">
      {{ resolvedTitle }}
    </div>
    <div class="tw-mb-10">
      <ng-container *ngTemplateOutlet="data.templateContent"> </ng-container>
    </div>
  } @else if (statusHeaderType) {
    <app-status-header
      class="tw-mb-4"
      [type]="statusHeaderType"
      [title]="resolvedTitle"
    ></app-status-header>
    <ng-container *ngTemplateOutlet="statusMessage"></ng-container>
  } @else {
    <div class="tw-mb-2 tw-text-xl tw-font-medium">
      {{ resolvedTitle }}
    </div>
    <div>
      @if (data.message) {
        @if (isMessageKey) {
          <p data-testid="confirmation-dialog-message">{{ data.message | i18n }}</p>
        } @else {
          <p data-testid="confirmation-dialog-message" [innerHTML]="safeHtmlMessage"></p>
        }
      }
    </div>
  }

  @if (!isReloading && statusHeaderType) {
    <div
      class="tw-mt-6 tw-flex tw-justify-end tw-items-center tw-gap-4 sm:tw-flex-col sm:tw-items-stretch sm:tw-gap-3"
    >
      @if (!data.singleButton) {
        <button
          class="glass-dialog__cancel-btn sm:tw-w-full sm:tw-text-center"
          data-testid="confirmation-dialog-cancel"
          [mat-dialog-close]="false"
        >
          {{ closeBtnOptions.text }}
        </button>
      }
      <button
        class="glass-dialog__confirm-btn sm:tw-w-full"
        [class.glass-dialog__confirm-btn--destructive]="data.destructive"
        [attr.data-testid]="confirmBtnOptions.testId"
        (click)="confirmBtnOptions.onClick()"
      >
        {{ confirmBtnOptions.text }}
      </button>
    </div>
  }

  @if (!isReloading && isStandard) {
    <div class="tw-mt-5 tw-flex tw-w-full tw-justify-between tw-gap-6">
      @if (!data.singleButton) {
        <app-gloss-button
          class="tw-w-full"
          [mat-dialog-close]="false"
          aria-label="Close dialog"
          [options]="closeBtnOptions"
        ></app-gloss-button>
      }
      <app-gloss-button
        class="tw-w-full"
        [class.tw-ml-auto]="data.singleButton"
        [options]="confirmBtnOptions"
      ></app-gloss-button>
    </div>
  }

  <ng-template #statusMessage>
    @if (data.message) {
      @if (isMessageKey) {
        <p
          data-testid="confirmation-dialog-message"
          class="tw-text-sm tw-text-dt-text-secondary tw-mb-0"
        >
          {{ data.message | i18n }}
        </p>
      } @else {
        <p
          data-testid="confirmation-dialog-message"
          class="tw-text-sm tw-text-dt-text-secondary tw-mb-0"
          [innerHTML]="safeHtmlMessage"
        ></p>
      }
    }
  </ng-template>
</div>
